const common = {
  "nav.home": "首頁",
  "nav.services": "服務",
  "nav.about": "關於 Medigreen",
  "nav.contact": "聯絡我們",
  "nav.cta": "聯絡我們",

  "footer.brand.desc": "原油及液化天然氣採購專業顧問服務。提供策略洞察與可量化的成果。",
  "footer.nav.title": "導覽",
  "footer.contact.title": "聯絡資訊",
  "footer.address": "1411 PALE SAN VITORES ROAD, STE 303,\nTAMUNING, GU",
  "footer.phone": "+1.671.482.0104",
  "footer.email": "info@medigreen.energy",
  "footer.copyright": "© 2026 Medigreen LLC. All rights reserved.",
  "footer.privacy": "隱私政策",
  "footer.terms": "使用條款",

  "common.readMore": "閱讀更多",
  "common.viewAll": "查看全部",
  "common.learnMore": "了解更多",
  "common.contactUs": "聯絡我們",
  "common.getStarted": "開始使用",
  "common.freeConsultation": "免費諮詢",
  "common.scheduleConsultation": "預約免費諮詢",
  "common.workWithUs": "與我們合作",
  "common.viewAllNews": "查看所有新聞",
  "common.viewAllServices": "查看所有服務",
  "common.startConversation": "開始對話",
  "common.learnMoreAboutUs": "深入了解我們",
};

export default common;
